<div class="min-h-screen bg-gray-50 flex flex-col font-prompt relative overflow-x-hidden pb-12">
    <!-- Decorative background elements -->
    <div
        class="absolute top-0 right-0 w-32 h-32 bg-amber-400 rounded-full mix-blend-multiply filter blur-2xl opacity-10 -translate-y-1/2 translate-x-1/2 pointer-events-none">
    </div>
    <div
        class="absolute top-48 left-0 w-24 h-24 bg-yellow-300 rounded-full mix-blend-multiply filter blur-xl opacity-10 -translate-x-1/2 pointer-events-none">
    </div>

    <!------------------------------------------ Header Section ------------------------------------>
    <div class="bg-(--background-color) rounded-b-[2rem] shadow-md pb-8 pt-10 px-4 relative z-10">
        <!-- Back Button -->
        <div class="absolute left-4 top-5 w-[40px] h-[40px] bg-white/10 hover:bg-white/20 text-white rounded-full shadow-md flex justify-center items-center cursor-pointer active:scale-95 transition-all z-20 backdrop-blur-sm border border-white/10"
            (click)="goback()">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5"
                stroke="currentColor" class="w-5 h-5 text-white">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
            </svg>
        </div>

        <!-- Header Titles -->
        <div class="text-center mt-1 px-10">
            <h1 class="text-lg font-bold text-(--main-text-color) tracking-wide">
                {{ currentLang === "TH" ? "ประวัติการชำระเงิน EV" : "EV Top Up History" }}
            </h1>
            <p class="text-xs text-(--sub-text-color) mt-1.5 leading-relaxed">
                {{ currentLang === "TH" ? "รายการเติมเงินสะสมสำหรับชาร์จรถไฟฟ้าย้อนหลัง 30 วัน" : "Your EV top-up and
                payment history for the last 30 days" }}
            </p>
        </div>
    </div>

    <!---------------------------------------- Segments Tab Selector ------------------------------------>
    <div class="px-4 mt-6 mb-2 animation-slide-up">
        <div class="bg-slate-100 p-1 rounded-2xl flex items-center shadow-inner">
            <button (click)="goback()"
                class="flex-grow py-2.5 text-xs font-medium rounded-xl text-slate-500 hover:text-slate-700 transition-all text-center">
                {{ currentLang === "TH" ? "เติมเงิน" : "Top Up" }}
            </button>
            <button
                class="flex-grow py-2.5 text-xs font-bold rounded-xl bg-white text-slate-800 shadow-sm transition-all text-center">
                {{ currentLang === "TH" ? "ประวัติการโอนเงิน" : "Transfer History" }}
            </button>
        </div>
    </div>

    <!------------------------------------------- Range Title ------------------------------------->
    <div
        class="px-4 py-2 flex items-center justify-between text-[11px] text-slate-400 font-bold uppercase tracking-wider animation-slide-up">
        <span>{{ currentLang === "TH" ? "ช่วงเวลา: 30 วันล่าสุด" : "Range: Last 30 Days" }}</span>
        <span class="bg-slate-200/50 px-2 py-0.5 rounded-full text-[9px]">{{ dataHistory.length }} {{ currentLang ===
            "TH" ? "รายการ" : "Transactions" }}</span>
    </div>

    <!------------------------------------------- History Cards List ------------------------------------->
    <div class="flex-1 px-4 overflow-y-auto space-y-3 z-10 custom-scrollbar animation-slide-up">

        <div *ngFor="let history of dataHistory"
            class="w-full bg-white rounded-2xl border border-slate-100 shadow-sm p-4 flex flex-col gap-3 relative overflow-hidden group">
            <!-- Left Status Indicator Bar -->
            <div class="absolute left-0 top-0 bottom-0 w-1 transition-transform duration-200 rounded-r"
                [ngClass]="history.topupMethod === 'Payment' ? 'bg-slate-400' : 'bg-emerald-400'"></div>

            <!-- Top Row: Date & Action Badge -->
            <div class="flex items-center justify-between">
                <div class="flex items-center gap-1.5 text-xs text-slate-400">
                    <img src="icons/calendar_month_slate.svg" class="w-5 h-5" />
                    <span class="font-medium">{{ history.paidDate | date : "dd/MM/yyyy HH:mm" }}</span>
                </div>
                <span class="text-[9px] font-black uppercase tracking-widest px-2 py-0.5 rounded-full"
                    [ngClass]="history.topupMethod === 'Payment' ? 'bg-slate-100 text-slate-600' : 'bg-emerald-50 text-emerald-600'">
                    {{ history.topupMethod === 'Payment' ? (currentLang === 'TH' ? 'ชำระเงิน' : 'Payment') :
                    (currentLang === 'TH' ? 'เติมเงิน' : 'Top Up') }}
                </span>
            </div>

            <!-- Middle Row: Main Info & Amount -->
            <div class="flex items-center gap-3">
                <!-- Icon Container -->
                <div class="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 shadow-inner"
                    [ngClass]="history.topupMethod === 'Payment' ? 'bg-slate-50 text-slate-600' : 'bg-emerald-50/50 text-emerald-500'">
                    <img src="icons/{{ history.topupMethod === 'Payment' ? 'electric_bolt_slate.svg' : 'account_balance_wallet_emerald.svg' }}"
                        class="w-5 h-5" />
                </div>

                <!-- Text Info -->
                <div class="flex-1 min-w-0 text-left">
                    <h4 class="text-sm font-bold text-slate-800 tracking-wide truncate">
                        {{ history.siteName || (currentLang === 'TH' ? 'เติมเงินเข้าระบบ' : 'Wallet Top Up') }}
                    </h4>
                    <p class="text-xs text-slate-400 mt-0.5 truncate">
                        {{ history.feeName }}
                    </p>
                </div>

                <!-- Price Amount (Right Side) -->
                <div class="text-right flex flex-col justify-center flex-shrink-0">
                    <span class="text-base font-black tracking-wide"
                        [ngClass]="history.topupMethod === 'Payment' ? 'text-slate-800' : 'text-emerald-500'">
                        {{ history.topupMethod === 'Payment' ? '-' : '+' }}{{ history.amount | number: '1.2-2' }}
                    </span>
                    <span class="text-[9px] font-bold text-slate-400 uppercase">THB</span>
                </div>
            </div>

            <!-- Bottom Row: Transaction/Top up ID -->
            <div class="pt-2.5 border-t border-slate-50 flex items-center justify-between text-[10px] text-slate-400">
                <span>{{ currentLang === "TH" ? "ไอดีทำรายการ: " : "Transaction ID: " }} <strong
                        class="text-slate-500">{{ history.transactionNo }}</strong></span>
                <span>{{ currentLang === "TH" ? "ผู้ชำระเงิน: " : "Payer: " }} <strong class="text-slate-500">{{
                        history.cpuName }}</strong></span>
            </div>
        </div>

        <!------------------------------------------- Empty State --------------------------------------->
        <div *ngIf="dataHistory.length === 0" class="flex flex-col items-center justify-center py-20 px-4 text-center">
            <div class="w-20 h-20 rounded-full bg-slate-100 flex items-center justify-center mb-4">
                <img src="icons/receipt_long_slate_dark.svg" class="w-5 h-5" />
            </div>
            <p class="text-sm font-bold text-slate-600">
                {{ currentLang === 'TH' ? 'ไม่พบประวัติการทำรายการ' : 'No Transaction History' }}
            </p>
            <p class="text-xs text-slate-400 mt-1.5 max-w-[240px]">
                {{ currentLang === 'TH' ? 'ไม่พบรายการเติมเงินสะสมในช่วง 30 วันที่ผ่านมา' : 'There are no transactions
                recorded in the past 30 days.' }}
            </p>
        </div>
    </div>
</div>

<!---------------------------------------- Loading ------------------------------------>
<app-pss-loading *ngIf="isLoading"></app-pss-loading>